<div class="crm-read-only-container" *ngIf="readOnly; else formField">
  <div class="crm-field-label">{{ label | translate }}</div>
  <div class="crm-field-value">
    <mat-chip-listbox *ngIf="control.value">
      <mat-chip *ngFor="let tag of control.value">{{ tag }}</mat-chip>
    </mat-chip-listbox>
  </div>
</div>
<ng-template #formField>
  <glxy-form-field>
    <glxy-label *ngIf="label">{{ label | translate }}</glxy-label>
    <mat-chip-grid #tagChips>
      <ng-container *ngFor="let tag of control.value; let tagIndex = index">
        <mat-chip-row *ngIf="!readOnly; else readonlyTags" (removed)="removeTag(tagIndex); saveField();">
          {{ tag || '-' }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <ng-template #readonlyTags>
          <glxy-badge [glxyTooltip]="tag">{{ tag || '-' }}</glxy-badge>
        </ng-template>
      </ng-container>
      <input
        #tagInput
        [placeholder]="maxTags !== null && control.value?.length >= maxTags ? '' : (addTagPrompt | translate)"
        maxlength="{{ maxTagLength }}"
        [formControl]="newTagControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="tagChips"
        [matChipInputAddOnBlur]="true"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addNewTag($event)"
        (focus)="isInputActive = true; initializeField();"
        (blur)="isInputActive = false; saveField();"
        [readonly]="maxTags !== null && control.value?.length >= maxTags"
      />
      <glxy-error *ngIf="maxTagLength !== null && newTagControl.value?.length === maxTagLength">
        {{ 'MODEL_DRIVEN_FORM.STRING_LIMIT_HINT' | translate : {characters: newTagControl.value?.length || 0} }}
      </glxy-error>
    </mat-chip-grid>
    <glxy-error *ngIf="maxTags !== null && control.value?.length === maxTags && isInputActive ">
      {{ maximumTagsError | translate : {maximumTags: control.value?.length || 0} }}
    </glxy-error>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectExistingTag($event)">
      <mat-option *ngFor="let tag of availableTags$ | async" [value]="tag" (mousedown)="$event.preventDefault()">
        {{ tag }}
      </mat-option>
    </mat-autocomplete>
    <crm-model-driven-form-error
      [objectType]="objectType"
      [fieldId]="fieldId"
      [label]="label"
      [control]="control"
      [validation]="validation"
    ></crm-model-driven-form-error>
  </glxy-form-field>
</ng-template>
